import React from "react";
import { subColor } from "@/lib/risk";

const LABELS = [
  { key: "party", label: "Party risk", testid: "subscore-party" },
  { key: "smoking", label: "Smoking risk", testid: "subscore-smoking" },
  { key: "damage", label: "Damage risk", testid: "subscore-damage" },
  { key: "fraud_refund", label: "Fraud / refund risk", testid: "subscore-fraud-refund" },
  { key: "communication", label: "Communication risk", testid: "subscore-communication" },
];

export const SubscoreBars = ({ subscores = {} }) => {
  return (
    <div className="space-y-4">
      {LABELS.map(({ key, label, testid }) => {
        const v = subscores[key] ?? 0;
        return (
          <div key={key} data-testid={testid}>
            <div className="mb-1.5 flex items-center justify-between text-sm">
              <span className="text-foreground/80">{label}</span>
              <span className="font-medium tabular-nums" style={{ color: subColor(v) }}>{v}</span>
            </div>
            <div className="h-2 w-full overflow-hidden rounded-full bg-muted">
              <div
                className="h-full rounded-full"
                style={{ width: `${v}%`, backgroundColor: subColor(v), transition: "width 0.4s ease" }}
              />
            </div>
          </div>
        );
      })}
    </div>
  );
};
